<template>
  <div>
    <list
      row-key="HouseId"
      ref="list"
      unit="员工资料"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="部门" v-if="showDp&&!isMB">
          <el-select v-model="params.DpId"  >
            <el-option v-for="item in dpList" :key="item.DpId" :value="item.DpId" :label="item.DpName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" v-if="isMB">
          <tree-select
            ref="treeSelect"
             
            :props="props"
            :options="TreeData"
            :value="params.DpId"
            :clearable="true"
            :accordion="true"
            style="width:178px;"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item> -->
        <el-form-item label="人员姓名">
          <el-input   v-model="params.EmpName" placeholder="请填写人员姓名" />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input   v-model="params.Mobile" type="number" placeholder="请填写手机号码" />
        </el-form-item>
        <el-form-item label="当前状态" v-if="!showDp">
          <el-select v-model="params.Status" style="width:178px;">
            <el-option label="在职" value="1"></el-option>
            <el-option label="离职" value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="部门" v-if="showDp"/>
        <el-table-column prop="EmpNo" label="人员工号" />
        <el-table-column prop="EmpName" label="人员姓名" />
        <el-table-column prop="Mobile" label="手机号码" />
        <el-table-column prop="HomeAddress" label="家庭住址" min-width="150" />
        <el-table-column prop="EntryDate" label="入职时间">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.EntryDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="Job" label="职务" />
        <el-table-column label="当前状态" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.Status==1">在职</el-tag>
            <el-tag type="danger" v-else>离职</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [listMixin],
  components: {
    list,
    treeSelect
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    showDp: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      api: require("@/api/basic/member").default,
      DpApi: require("@/api/basic/dp").default,
      params: {
        DpId: null,
        EmpName: "",
        Mobile: "",
        Status: null,
      },
      props: {
        // 配置项（必选）
        value: "DpId",
        label: "DpName",
        children: "children",
        // disabled:true
      },
      TreeData: [],
      dpList: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted(){
    // this.DpApi.list({}).then(res => {
    //   this.dpList = res.Data;
    //   this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
    // })
  },
  methods: {
    onTreeSelect(t) {
      if (!t) return;
      if (t.DpId > 0) {
        this.getData({ DpId: t.DpId });
      } else {
        this.getData({});
      }
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>